import partialRight from 'lodash/partialRight'
import property from 'lodash/property'

import {search as emojiSearch} from 'utils/emoji.utils'
import ListItem from './ListItem'

export const MAX_EMOJI_ITEMS = 6
export const component = ListItem
export const dataProvider = partialRight(emojiSearch, MAX_EMOJI_ITEMS)
export const output = property('char')

export default {':': {component, dataProvider, output}}
